import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export default function ProjectsAttention({ projects }) {
    const navigate = useNavigate();

    if (!projects || projects.length === 0) {
        return (
            <div className="dashboard_section">
                <div className="section_header">
                    <h3><NotificationsActiveIcon /> Projects Requiring Attention</h3>
                </div>
                <div className="empty_state small">
                    <p>No projects need your attention right now.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard_section">
            <div className="section_header">
                <h3><NotificationsActiveIcon /> Projects Requiring Attention</h3>
            </div>
            <div className="attention_list">
                {projects.map((project) => (
                    <div 
                        key={project.id} 
                        className="attention_item"
                        onClick={() => navigate(`/project-details/${project.id}`)}
                    >
                        <div className="attention_item_content">
                            <h4 className="attention_title">
                                {project.project_name.length > 50 
                                    ? `${project.project_name.slice(0, 50)}...` 
                                    : project.project_name}
                            </h4>
                            <div className="attention_meta">
                                <span className="meta_item">
                                    <VisibilityIcon />
                                    {project.total_bids || 0} {(project.total_bids || 0) === 1 ? 'bid' : 'bids'}
                                </span>
                                <span className="meta_item">
                                    <CalendarTodayIcon />
                                    Starts {moment(project.project_start_date).format("MMM DD")}
                                </span>
                            </div>
                        </div>
                        {project.bids_count > 0 && (
                            <div className="attention_badge">
                                <span className="new_bids_badge">{project.bids_count} new</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
